import React from 'react';

export type ABTestContextValue = {
  abTastyData?: Record<string, string>;
  [key: string]: string | Record<string, string> | undefined;
};

export const ABTestContext = React.createContext<ABTestContextValue>({} as ABTestContextValue);
